import React, { useState } from "react";
import { PaymentElement as PaymentElementDevelopment, useXpay as useXpayDevelopment } from "@xstak/xpay-element-stage-v2";
import { PaymentElement as PaymentElementProduction, useXpay as useXpayProduction } from "@xstak/xpay-element-live-v2";
import { LoadingButton } from "@mui/lab";
import { Box, Stack } from "@mui/material";
import axios from "axios";

export const WidgetPaymentForm = ({ paymentData, timeLeft, decodedPath }) => {

  const useXpay = process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === "staging" ? useXpayProduction : useXpayDevelopment;
  const PaymentElement = process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === "staging" ? PaymentElementProduction : PaymentElementDevelopment;
  const xpay = useXpay();

  const options = {
    override: true,
    fields: {
      creditCard: {
        placeholder: "4234 1234 1234 1234",
        label: "Enter your credit card",
      },
      exp: {
        placeholder: "Exp. Date",
      },
    },
    style: {
      ".input": {
        border: "1px solid black",
        "border-radius": "15px",
      },
      ".invalid": {},
      ".label": {
        "font-size": "18px",
      },
      ":focus": {},
      ":hover": {},
      "::placeholder": {},
      "::selection": {},
    },
  };

  const [cardNetwork, setCardNetwork] = useState("");
  const [cardLastDigits, setCardLastDigits] = useState("");
  const [cardStartDigits, setCardStartDigits] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [filledAllCardDetails, setFilledAllCardDetails] = useState(false);

  let shipping = {
    address1: "abc",
    city: "Islamabad",
    country: "Pakistan",
    phone: "03415555555",
    zip: "12345",
    shipping_method: "Standard",
  };

  const pay = async () => {
    setIsLoading(true);
    let dataForCreateIntent = paymentData?.dataForCreateIntent;
    let customer = paymentData?.customer;
    let dataForPayment = {
      amount: paymentData?.amount,
      currency: "PKR",
      shipping: shipping,
      card: {
        cardNetwork: cardNetwork,
        cardLastDigits: cardLastDigits,
        cardStartDigits: cardStartDigits,
      },
    };

    let customer1 = {
      name: `${customer?.firstName} `.trim(),
      email: customer?.email,
      phone: customer?.phone,
    };

    try {
      const response = await createReservationSlot(dataForCreateIntent, dataForPayment, customer);
      const paymentIntentResponse = response.data;

      if (paymentIntentResponse?.response?.success === true) {
        const { pi_client_secret, encryptionKey } = paymentIntentResponse.response.data;
        try {
          const result = await xpay.confirmPayment(
            "card",
            pi_client_secret,
            customer1,
            encryptionKey
          );

          await paymentSuccess(paymentIntentResponse);
          return result.message;
        } catch (error) {
          await paymentFailed(paymentIntentResponse, error.message);
          return error;
        }
      }
    } catch (error) {
      console.error("Payment handling failed:", error);
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  const paymentSuccess = async (paymentIntentResponse) => {
    const finalData = {
      reservationId: paymentIntentResponse.reservation.id,
      paymentIntent: paymentIntentResponse.response.data._id,
      transactionId: paymentIntentResponse.transaction.id,
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/reservationWidget/paymentSuccess`,
        finalData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response) {
        let queryParams = new URLSearchParams();
        queryParams.set("paymentSuccess", "true");
        let separator = decodedPath.includes("?") ? "&" : "?";
        let finalUrl = decodedPath + separator + queryParams.toString();
        window.location.href = finalUrl;
      }
      return response;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };

  const paymentFailed = async (paymentIntentResponse, message) => {
    const finalData = {
      reservationId: paymentIntentResponse?.reservation?.id,
      transactionId: paymentIntentResponse?.transaction?.id,
      message: message,
    };

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/reservationWidget/paymentFailed`,
        finalData,
        { headers: { "Content-Type": "application/json" } }
      );
      if(response){

        let queryParams = new URLSearchParams();
        queryParams.set("paymentFailed", "false");
        let separator = decodedPath.includes("?") ? "&" : "?";
        let finalUrl = decodedPath + separator + queryParams.toString();
        window.location.href = finalUrl;

      }
      return response;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };

  const createReservationSlot = async (dataForCreateIntent, dataForPayment, customer) => {
    let finalData = {
      ...dataForCreateIntent,
      customer: customer,
      shipping: {
        ...dataForPayment?.shipping,
      },
      card: {
        ...dataForPayment?.card,
      },
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/reservationWidget`,
        finalData,
        { headers: { "Content-Type": "application/json" } }
      );
      return response;
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  };

  return (
    <>
      <Box p={2}>
        <div>
          <Stack
            alignItems="flex-start"
            sx={{
              width: 1,
            }}
          ></Stack>
        </div>
        <PaymentElement
          options={options}
          onBinDiscount={(event) => {
            setCardLastDigits(event?.data?.last4digts ?? null);
            setCardStartDigits(event?.data?.bin ?? null);
            setCardNetwork(event?.data?.card_network ?? null);
          }}
          onReady={(event) => {
            setFilledAllCardDetails(event?.ready);
          }}
        />{" "}
        {filledAllCardDetails && (
          <LoadingButton
            fullWidth
            color="inherit"
            size="large"
            type="submit"
            variant="contained"
            loading={isLoading}
            onClick={pay}
            disabled={timeLeft <= 0}
            sx={{
              bgcolor: "#fda92d",
              color: (theme) =>
                theme.palette.mode === "black" ? "common." : "grey.800",
              "&:hover": {
                bgcolor: "#B66816",
                color: (theme) =>
                  theme.palette.mode === "black" ? "common.white" : "grey.800",
              },
            }}
          >
            Pay Now
          </LoadingButton>
        )}
      </Box>
    </>
  );
};
